/* ==========================================================================
   Content Animation
   ========================================================================== */

// ...

import gsap from "gsap";
import splitText from "gsap/SplitText";
import scrollTrigger from "gsap/ScrollTrigger";

// Reveal text content from below
function textReveal() {
  gsap.registerPlugin(splitText, scrollTrigger);
  gsap.config({ nullTargetWarn: false });

  const innerSplit = new splitText(".text-reveal-ani", {
    type: "lines",
    linesClass: "split-child",
  });

  scrollTrigger.batch(innerSplit.lines, {
    start: "top +700",
    end: "bottom 20%",
    onEnter: (batch) =>
      gsap.to(batch, {
        autoAlpha: 1,
        delay: 0.2,
        yPercent: 0,
        duration: 1.5,
        stagger: 0.5,
        ease: "power4",
      }),
  });

  gsap.set(innerSplit.lines, {
    duration: 1.5,
    yPercent: 100,
    ease: "power4",
    stagger: 0.1,
  });
}

// Fade in images
function imageFade() {
  gsap.registerPlugin(scrollTrigger);
  const imageFade = gsap.utils.toArray(".fade-in");
  imageFade.forEach((image: any) => {
    scrollTrigger.create({
      trigger: image,
      toggleClass: "active",
      start: "top +700",
      end: "bottom 20%",
      once: true,
    });
  });
}

// Fade in text
function textAnimation() {
  gsap.registerPlugin(scrollTrigger);
  const textFade = gsap.utils.toArray(".text-ani");
  textFade.forEach((text: any) => {
    scrollTrigger.create({
      trigger: text,
      toggleClass: "active",
      start: "top bottom",
      end: "bottom 20%",
      once: true,
      scrub: true,
    });
  });
}

window.addEventListener("load", function () {
  textReveal();
  textAnimation();
  imageFade();
});
